 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import { useLayoutEffect, useState} from 'react'
import {ElementWidth} from '../types/constEnums'
import useResizeObserver from './useResizeObserver'

const useCardsPerRow = (wrapperRef) => {
  const [cardsPerRow, setCardsPerRow] = useState(null)

  const getCardsPerRow = () => {
    const {current: el} = wrapperRef
    const width = _optionalChain([el, 'optionalAccess', _ => _.clientWidth])
    if (!width) return
    const cardsPerRow = Math.max(Math.floor(width / ElementWidth.MEETING_CARD_WITH_MARGIN), 1)
    setCardsPerRow(cardsPerRow)
  }

  useLayoutEffect(getCardsPerRow, [wrapperRef])
  useResizeObserver(getCardsPerRow, wrapperRef)
  return cardsPerRow
}

export default useCardsPerRow
